import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import screens from './checkoutScreens';
import routes from './routes';
import { reducer as modal } from '../redux/modal';
import transaction from './transaction';
import loading from './loading';
import errors from './errors';
import audioPlayer from './audioPlayer';
import videoOverlay from './videoOverlay.reducer';

const rootReducer = combineReducers({
  screens,
  routes,
  modal,
  transaction,
  loading,
  errors,
  form: formReducer,
  audioPlayer,
  videoOverlay,
});

export default rootReducer;
